import React from 'react';
import Manager_web_portal from '../../../layout/Manager_web_portal';
import RunningCaseDepositsPage from '../../../components/RunningCaseDepositsPage';

const ManagerRunningCaseDeposits = () => (
  <RunningCaseDepositsPage Layout={Manager_web_portal} backPath="/manager/running-cases" />
);

export default ManagerRunningCaseDeposits;
